const CURATED_TOOLS = [
  { name: 'GitHub Copilot', tagline: 'Code 2× faster', description: 'Inline completions. ~45 min saved per feature.' },
  { name: 'Cursor', tagline: 'AI-native IDE', description: 'Refactor entire files with a single instruction.' },
  { name: 'ChatGPT + Excalidraw', tagline: 'System design', description: 'Brainstorm tradeoffs, sketch architectures.' },
  { name: 'Datadog Watchdog', tagline: 'Debug faster', description: 'Auto-links slow endpoints to recent deploys.' },
  { name: 'Notion AI', tagline: 'Sound senior', description: 'Bullet notes → polished RFC in 5 minutes.' },
  { name: 'CodeRabbit', tagline: 'PR reviews', description: 'AI reviews PRs before humans see them.' },
  { name: 'Perplexity', tagline: 'Research', description: 'Cited answers that replace 20 SO tabs.' },
  { name: 'v0 / Bolt', tagline: 'UI prototypes', description: 'Sketch → working UI in seconds.' },
  { name: 'Warp', tagline: 'AI terminal', description: 'Autocompletes shell commands, explains errors.' }
];

export default CURATED_TOOLS;
